export default "__VITE_ASSET__774d9178__"